import React from 'react'

function Address({
  children,
}: {
  children?: {
    address: string
    address2: string
    city: string
    state: string
    country: string
    zip: string
  }
}) {
  if (!children) {
    return null
  }

  const { address, address2, city, state, zip } = children
  return (
    <>
      {address}
      <br />
      {address2 && (
        <>
          {address2}
          <br />
        </>
      )}
      {city}, {state} {zip}
    </>
  )
}
export default Address
